

























































import { Component, Vue } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, CreateTransporterDriverProfile } from '@/types/request';
import { MedTransGoConstants } from '@/util/constants';
import { TransporterLoc } from '@/types/entity';
import { CommonUtils } from '@/util/commonUtils';
import { ModelSelect } from 'vue-search-select';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
// tslint:disable-next-line: no-var-requires
const ProfileFormData = require('../../config/ProfileFormData');

@Component({
    mixins: [validationMixin],
    components: {
            ModelSelect,
    },
    data() {
        return {
            licenceNumber: '',
            licenceState: '',
            birthDate: '',
            locationId: '',
            expireDate: '',
            options: [],
            locationOptions: [],
            licenceStates: ProfileFormData.licenceStates,
        };
    },
    validations: {
        licenceNumber: {
            required,
        },
        licenceState: {
            required,
        },
        birthDate: {
            required,
        },
        expireDate: {
            required,
        },
    },
})

export default class AddTransporterDriverDetailsModal extends Vue {
    private show = true;
    private maxDate = new Date();
    private locations: TransporterLoc[] | undefined = [];

    public mounted() {
        this.$data.options = [];
        this.getLocation();

        this.maxDate.setFullYear(this.maxDate.getFullYear() - 23);
        this.$data.licenceStates.forEach((licenceState: any) => {
                const option = {
                    value: licenceState.name,
                    text: licenceState.name,
                };
                this.$data.options.push(option);
            });

    }

     private async getLocation() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/location/list`,
                loaderEvent: {
                    show: true,
                },
            };
        const response = await iHttpService.get<TransporterLoc[]>(apiRequest);
        if (response.success && response.data) {
                this.$data.locationOptions = [];
                this.locations = response.data as any;
                response.data.forEach((location) => {
                const option = {
                    value: location.id,
                    text: location.branchName,
                };
                this.$data.locationOptions.push(option);
                });
            } else {
                CommonUtils.showError(response);
            }
    }

    private async addTransporterAsDriver() {
        const iHttpService = ObjectFactory.getHttpService();
        const addTransporterAsDriver: CreateTransporterDriverProfile = {
            birthDate: this.$data.birthDate,
            expireYear: this.$data.expireDate,
            licenceNo: this.$data.licenceNumber,
            licenceState: this.$data.licenceState,
            locationId: this.$data.locationId,
        };
        const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/TransporterAsdriver/add`,
                data: addTransporterAsDriver,
                loaderEvent: {
                    show: true,
                },
            };
        const response = await iHttpService.post<any>(apiRequest);
        if (response.success && response.data) {
            const toastEvent: ToastEvent = {
                    message: 'Driver Added Successfully',
                    title: 'Success',
                    timeout: 5000,
                    varient: 'success',
                };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$emit('success');
            } else {
                CommonUtils.showError(response);
                this.close();
            }
    }

    private close() {
        this.$emit('close');
    }

 }
